import { render, staticRenderFns } from "./new-project-quote.vue?vue&type=template&id=3457a736"
import script from "./new-project-quote.vue?vue&type=script&lang=js"
export * from "./new-project-quote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports